var INTERNAL_HOSTS = ["superhivemarket.com", "www.superhivemarket.com"]

function isInternalUrl(href) {
  try {
    var hostname = new URL(href).hostname.toLowerCase()
    return (
      INTERNAL_HOSTS.indexOf(hostname) !== -1 ||
      hostname.endsWith(".superhivemarket.com")
    )
  } catch (e) {
    return false
  }
}

$(document).on("click", "body.inbox-layout .quarantine a[href]", function (e) {
  var href = $(this).attr("href")
  if (!href || !href.match(/^https?:\/\//i)) return
  if (isInternalUrl(href)) return

  e.preventDefault()
  $("#external-link-url").text(href)
  $("#external-link-continue").attr("href", href)
  $("#external-link-modal").modal("show")
})
